import React from 'react';
import Select, { components } from 'react-select';
import { Controller } from 'react-hook-form';

import TerminalIcon from '../assets/terminal-icon';
import MapMarkerHomeIcon from '../assets/map-marker-home-icon';

const LeftIcon = {
  terminal: <TerminalIcon />,
  marker: <MapMarkerHomeIcon />
};

const CustomOption = ({ children, ...props }) => {
  return (
    <components.Option {...props}>
      <div className="flex gap-2 cursor-pointer">
        <div className="text-black">
          {LeftIcon[props?.label?.toLowerCase()?.includes?.('Terminal') ? 'terminal' : 'marker']}
        </div>
        <div>{props.label}</div>
      </div>
    </components.Option>
  );
};

const Dropdown = ({ name, label, placeholder, values, control, error, rules, isFindTransport }) => {
  return (
    <>
      <label className="block mb-2 text-base text-left font-medium text-gray-900">{label}</label>
      <Controller
        control={control}
        name={name}
        render={({ field: { onChange, value } }) => {
          return (
            <Select
              className="text-left"
              placeholder={
                <div className="text-left text-gray-400 text-ellipsis overflow-hidden whitespace-nowrap">
                  {placeholder}
                </div>
              }
              options={values}
              value={values?.find?.((v) => v?.value === value)}
              onChange={(val) => onChange(val?.value)}
              components={{
                DropdownIndicator: () => null,
                IndicatorSeparator: () => null,
                ...(isFindTransport ? { Option: CustomOption } : {})
              }}
            />
          );
        }}
        rules={rules}
      />
      {error && <p className="text-red-500 text-left mt-1">{label} tidak boleh kosong</p>}
    </>
  );
};

export default Dropdown;
